export default __webpack_public_path__ + "static/media/3.d6c75106.png";